<template>
  <v-dialog v-model="showMessage" persistent max-width="480">
    <v-card class="pa-3" width="480">
      <v-card-title class="headline">
        <font-awesome-icon
          v-if="showSendBtn"
          class="mr-2"
          :style="{ color: '#424242' }"
          size="lg"
          :icon="['fal', 'paper-plane']"
        />
        {{ messageTitle }}
      </v-card-title>
      <v-form v-model="valid" ref="form" lazy-validation>
        <v-card-text>
          <v-flex v-if="showTextArea">
            <b>
              {{ messagesComments }}
            </b>
            <v-textarea
              v-model="comments"
              color="#C46D24"
              box
              name="comments"
              label="Comentarios"
              counter="280"
              maxlength="280"
              required
              :rules="[v => !!v || 'Item requerido']"
              @change="addComments(comments)"
            ></v-textarea>
          </v-flex>
          {{ messageInfo }}
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            v-if="showCancelBtn"
            class="text-capitalize"
            color="red darken-1"
            dark
            depressed
            @click="cancel"
          >
            <font-awesome-icon
              class="mr-2"
              :style="{ color: '#FFFFFF' }"
              size="lg"
              :icon="['fal', 'times-circle']"
            />
            Cancelar
          </v-btn>

          <v-btn
            v-if="showSendBtn"
            class="text-capitalize"
            color="#466EA5"
            :dark="valid"
            depressed
            @click="accept"
            :disabled="!valid"
          >
            <font-awesome-icon
              class="mr-2"
              :style="{ color: '#FFFFFF' }"
              size="lg"
              :icon="['fal', 'paper-plane']"
            />
            Enviar
          </v-btn>

          <v-btn
            v-if="showOkBtn"
            class="text-capitalize"
            color="#466EA5"
            dark
            depressed
            @click="acceptAlt"
          >
            <font-awesome-icon
              class="mr-2"
              :style="{ color: '#FFFFFF' }"
              size="lg"
              :icon="['fal', 'check-circle']"
            />
            Aceptar
          </v-btn>
        </v-card-actions>
      </v-form>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
export default {
  name: "Messages",
  data() {
    return {
      comments: "",
      valid: false
    };
  },
  computed: {
    ...mapGetters([
      "messagesComments",
      "showTextArea",
      "showMessage",
      "showCancelBtn",
      "showSendBtn",
      "showOkBtn",
      "dataAction",
      "actionMessage",
      "messageTitle",
      "messageInfo"
    ])
  },
  methods: {
    ...mapActions(["showGeneralMessage", "addComments"]),
    acceptAlt() {
      const payload = {
        showMessage: false,
        showCancelBtn: false,
        showSendBtn: false,
        showOkBtn: false,
        action: "",
        data: null,
        messageTitle: "",
        messageInfo: "",
        messagesComments: ""
      };
      this.showGeneralMessage(payload);
    },
    cancel() {
      const payload = {
        showMessage: false,
        showCancelBtn: false,
        showSendBtn: false,
        showOkBtn: false,
        action: "",
        data: null,
        messageTitle: "",
        messageInfo: "",
        messagesComments: ""
      };
      this.showGeneralMessage(payload);
    },
    accept() {
      if (this.$refs.form.validate()) {
        // console.log("SEND FORM!");
        this.$store.dispatch(this.actionMessage, this.dataAction);
      } else console.log("VERIFY FORM!");
    }
  }
};
</script>
